// API temporário para compatibilidade com hooks existentes
import { apiRequest } from './queryClient';
import { getApiBaseUrl } from '@/config/production';

// Garantir que não há barra dupla na construção da URL
const getApiBase = () => {
  const base = getApiBaseUrl();
  return base.replace(/\/+$/, ''); // Remove barras finais
};

const API_BASE = `${getApiBase()}/api`;

// API object with HTTP methods para compatibilidade
export const api = {
    get: async (url: string, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('GET', `${API_BASE}${url}`, undefined, options?.headers);
        const data = await response.json();
        return { data }; // Retornar no formato esperado pelos hooks
    },
    post: async (url: string, data?: any, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('POST', `${API_BASE}${url}`, data, options?.headers);
        const responseData = await response.json();
        return { data: responseData };
    },
    put: async (url: string, data?: any, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('PUT', `${API_BASE}${url}`, data, options?.headers);
        const responseData = await response.json();
        return { data: responseData };
    },
    patch: async (url: string, data?: any, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('PATCH', `${API_BASE}${url}`, data, options?.headers);
        const responseData = await response.json();
        return { data: responseData };
    },
    delete: async (url: string, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('DELETE', `${API_BASE}${url}`, undefined, options?.headers);

        // Se a resposta está vazia (status 204), retornar objeto vazio
        if (response.status === 204 || response.statusText === 'No Content') {
            return { data: {} };
        }

        // Se há conteúdo, tentar fazer parse do JSON
        const text = await response.text();
        if (!text) {
            return { data: {} };
        }

        try {
            return { data: JSON.parse(text) };
        } catch (error) {
            console.warn('Erro ao fazer parse da resposta DELETE:', error);
            return { data: {} };
        }
    }
};
